<template>
    <EXTooltip 
        placement="top"
        title="Attachments"
        :description="attachmentsDescription"
        :delay="200"
    >
        <div class="role-attachments-badge">
            <AttachedPositionsToRole :active="activePositions" :inactive="inactivePositions" />
            <AttachedResponsibilitiesToRole :active="activeResponsibilities" :inactive="inactiveResponsibilities" />
        </div>
    </EXTooltip>
</template>

<script setup>
import { defineProps, computed } from "vue";
import AttachedPositionsToRole from "@components/AttachedPositionsToRole/AttachedPositionsToRole.vue";
import AttachedResponsibilitiesToRole from "@components/AttachedResponsibilitiesToRole/AttachedResponsibilitiesToRole.vue";
import EXTooltip from "@components/tooltip/EXTooltip.vue";

const props = defineProps({
    activePositions: {
        type: Number,
        default: 0
    },
    inactivePositions: {
        type: Number,
        default: 0
    },
    activeResponsibilities: {
        type: Number,
        default: 0
    },
    inactiveResponsibilities: {
        type: Number,
        default: 0
    }
});

const attachmentsDescription = computed(() => {
    const parts = [];
    
    if (props.activePositions === 0) {
        parts.push('No active positions attached');
    } else {
        parts.push(`${props.activePositions} active position${props.activePositions !== 1 ? 's' : ''} attached`);
    }
    
    if (props.inactivePositions > 0) {
        parts.push(`${props.inactivePositions} draft position${props.inactivePositions !== 1 ? 's' : ''} attached`);
    }
    
    if (props.activeResponsibilities === 0) {
        parts.push('No active responsibilities attached');
    } else {
        parts.push(`${props.activeResponsibilities} active responsibilit${props.activeResponsibilities !== 1 ? 'ies' : 'y'} attached`);
    }
    
    if (props.inactiveResponsibilities > 0) {
        parts.push(`${props.inactiveResponsibilities} draft responsibilit${props.inactiveResponsibilities !== 1 ? 'ies' : 'y'} attached`);
    }
    
    return parts.join('\n');
});
</script>

<style scoped>
.role-attachments-badge {
    display: inline-flex;
    padding: 0 5px;
    align-items: center;
    gap: 3px;
}
.role-attachments-badge:hover {
    border-radius: 6px;
    background: #EBE9FE;
    cursor: pointer;
}
</style>